<div class="pane">
    <div class="damagetypes">
        <ul>
            <li *ngFor="let types of damageTypes" [@slideUpDownList]="types.active">
                <ng-template *ngIf="types.editing; then edit; else show"></ng-template>
                <ng-template #show>
                    {{types.name}}
                    <div class="actions">                        
                        <button mat-icon-button (click)="editType(types)" matTooltip="Rediger"><i class="fa fa-pencil"></i></button>
                        <button mat-icon-button *ngIf="!types.inUse" (click)="deleteType(types)" matTooltip="Slet"><i class="fa fa-trash"></i></button>
                    </div>
                </ng-template>
                <ng-template #edit>
                    <form (ngSubmit)="f.form.valid && saveType(types)" #f="ngForm">
                        <input type="text" name="name" required [(ngModel)]="types.name" />
                        <div class="actions">
                            <button mat-icon-button type="button" (click)="cancelEditType(types)" matTooltip="Annuller"><i class="fa fa-times"></i></button>
                            <button mat-icon-button *ngIf="types.active" (click)="toggleType(types)" matTooltip="Aktiv"><i class="fa fa-toggle-on"></i></button>
                            <button mat-icon-button *ngIf="!types.active" (click)="toggleType(types)" matTooltip="Ikke aktiv"><i class="fa fa-toggle-off"></i></button>
                            <button mat-icon-button type="submit" matTooltip="Gem"><i class="fa fa-save"></i></button>
                        </div>
                    </form>
                </ng-template>
            </li>
        </ul>
        <div class="create">
            <form>
                <input [(ngModel)]="newTypeName" (keyup.enter)="createType()" name="newTypeName" />
                <br>
                <button (click)="createType()" [disabled]="!newTypeName" >Opret skadetype</button>
            </form>
        </div>
    </div>
</div>
